import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Loader from '../../misc/Loader';
import Dialog from '@mui/material/Dialog';
import IconClose from '../../icons/IconClose';
import IconButton from '@mui/material/IconButton';
import CartArticle from './components/CartArticle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import ButtonWithIcon from '../../controls/ButtonWithIcon';
import IconCheckCircle from '../../icons/IconCheckCircle';
import useRecomendacion from '../../../services/intelafApiClient/handler/useRecomendacion';
import useSuggestHandler from '../../../redux/handler/useSuggestHandler';
import useCheckOutHandler from '../../../redux/handler/useCheckOutHandler';
import { styled } from '@mui/material/styles';
import { Divider } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const ModalRecomendacion = () => {
  const navigate = useNavigate();
  const [ open, setOpen ] = useState(false);
  const { checkout, carrito } = useCheckOutHandler();
  const { loader, productos, handleGetProducts } = useRecomendacion();
  const { openModal, CodeProduct, handlerCloseModal } = useSuggestHandler();

  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);

  useEffect(() => {
    if (CodeProduct) {
      handleGetProducts(CodeProduct, checkout?.SucursalDeEntrega?.CodigoSucursal);
    }
  }, [CodeProduct]);

  const handleClick = () => {
    setOpen(false);
    handlerCloseModal();
    navigate("/Carrito");
  };

  const handleOnClose = () => {
    setOpen(false);
    handlerCloseModal();
  };

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = '' };
  }, [open]);

  const getCantidadEnCarrito = (codigo) => {
    const item = carrito?.Items?.find(item => item.CodigoInventario === codigo);
    return item ? item.Cantidad : 0;
  };

  return (
    open &&
    <Dialog 
      open={open} 
      onClose={handleOnClose}
      disableScrollLock={true}
      PaperComponent={ !loader && productos.length === 0 ? StyledNoContent : StyledPaper}
    >
      <StyledIconButton
        aria-label="close"
        onClick={handleOnClose}
        size="large"
      >
        <IconClose width={24} height={24} fill="#888" />
      </StyledIconButton>
      <TitleContainer>
        <StyledChip
          icon={<IconCheckCircle fill='#00D25B' height={24} width={24} />}
          label={
            <span style={{ color: '#00D25B', fontWeight: 600 }}>
              Se añadió { CodeProduct?.trim() !== '' ? CodeProduct : 'el producto'} a tu carrito.
            </span>
          }
        />
      </TitleContainer>
      {
        loader ? 
        <DialogContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Loader/>
        </DialogContent>
        :
        productos.length > 0 &&
        <>
          <TextContainer>{'También te podría interesar'}</TextContainer>
          <DialogContent
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              maxHeight: productos.length > 4 ? 420 : 'none',
            }}
          >
            {
              productos.map((producto, index) => (
                <div key={index}>
                  { index > 0 ? <Divider style={{ backgroundColor: '#f5f5f5', margin: '15px 0px' }}/> : <></>}
                  <CartArticle producto={producto} cantidadEnCarrito={getCantidadEnCarrito(producto.Codigo)} />
                </div>
              ))
            }
          </DialogContent>
        </>
      }
      <StyledDialogActions>
        <StyledButton
          text='SEGUIR COMPRANDO'
          onClick={handleOnClose}
          className='buttonWithIcon-aqua'
          margin={0}
        ></StyledButton>
        <StyledButton
          text='IR A MI CARRITO'
          onClick={handleClick}
          className='buttonWithIcon-orange'
          margin={0}
        ></StyledButton>
      </StyledDialogActions>
    </Dialog>
  );
};

const StyledIconButton = styled(IconButton)({
  position: 'absolute',
  right: 15,
  top: 12,
  color: '#888',
  zIndex: 2,
});

const TitleContainer = styled('div')({
  display: 'flex',
  justifyContent: 'start',
  marginBottom: 16,
  '@media (max-width:600px)': {
    marginTop: '40px',
  },
});

const TextContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontFamily: 'Hubot Sans',
  marginBottom: 12,
  fontSize: 17,
  fontWeight: 700,
  color: '#131415A3',
});

const StyledChip = styled(Chip)({
  background: 'rgba(0, 210, 91, 0.07)',
  borderRadius: '25px',
  padding: '8px 20px',
  fontSize: 15,
  fontWeight: 700,
  color: '#00D25B',
  boxShadow: 'none',
  border: 'none',
  '@media (max-width:600px)': {
    fontSize: 13,
    maxWidth: '100%',
    marginTop: 0,
  },
});

const StyledDialogActions = styled(DialogActions)({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '12px',
  gap: '16px',
  '@media (max-width:600px)': {
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
  },
});

const StyledButton = styled(ButtonWithIcon)({
  borderRadius: '25px',
  maxWidth: '200px',
  width: '100%',
  '@media (max-width:600px)': {
    maxWidth: '100%',
    width: '100%',
    display: 'block',
  },
});

const StyledPaper = styled(Paper)(({ theme }) => ({
  width: '60%',
  height: 'auto',
  maxHeight: '65%',
  transition: 'height 0.3s',
  borderRadius: '25px',
  padding: '20px',
  [theme.breakpoints.down('sm')]: {
    width: '98%',
    height: 'auto',
    minHeight: '40%',
    maxHeight: '85%',
  },
}));

const StyledNoContent = styled(Paper)(({ theme }) => ({
  width: '520px',
  height: '150px',
  borderRadius: '25px',
  padding: '20px',
  [theme.breakpoints.down('sm')]: {
    width: '85%',
    height: 'auto',
    maxHeight: '40%',
  },
}));

export default ModalRecomendacion;